import { lazy, Suspense } from 'react'

import { QRADatasetRowEntry, QRARowEntryCRID } from '$/types'
import LoadingSpinner, {
  SpinnerWithOverlay
} from 'common/components/LoadingSpinner'
import type { QRATableViewType } from 'common/components/QRATableWrapper'
import { ISystemTableViewProps } from 'features/RiskManagement/Components/Tables'
import CSVExportButton from 'features/RiskManagement/Components/Tables/Toolbar/CSVExportButton'
import GroupColumns from 'features/RiskManagement/Components/Tables/Toolbar/GroupColumns'

import { quickFilterParser } from '../utils/data'
import { autoSizeAllColumns } from '../../../helpers'

const QRATableWithToolbarLazy = lazy<
  QRATableViewType<QRADatasetRowEntry & QRARowEntryCRID>
>(() => import('../../../../../common/components/QRATableWrapper/QRATableView'))

const SystemTableView = ({
  showLoading = false,
  colDefs,
  rowData,
  groupColumns,
  setGroupColumns,
  rowSelectCB,
  mutationTrigger,
  exportParams
}: ISystemTableViewProps) => {
  return (
    <div className='flex flex-1'>
      <div className='mt-2 flex flex-1 flex-col bg-white p-2'>
        <Suspense fallback={<SpinnerWithOverlay />}>
          <LoadingSpinner isLoading={showLoading}>
            <QRATableWithToolbarLazy
              tableClassName='ag-theme-lighthouse'
              toolbarContent={
                <>
                  <div
                    className={[
                      'flex items-center',
                      'mx-4 font-medium',
                      'rounded-sm leading-none text-gray-700'
                    ].join(' ')}
                  >
                    <CSVExportButton
                      mutationTrigger={mutationTrigger}
                      exportParams={exportParams}
                    />
                  </div>
                  <GroupColumns
                    groupColumns={groupColumns}
                    setGroupColumns={setGroupColumns}
                  />
                </>
              }
              colDefs={colDefs}
              rowData={rowData || []}
              quickFilterParser={quickFilterParser}
              rowSelectCB={(rows) => {
                rowSelectCB?.(rows[0])
              }}
              onFirstDataRendered={autoSizeAllColumns}
            />
          </LoadingSpinner>
        </Suspense>
      </div>
    </div>
  )
}

export default SystemTableView
